import {
  InvoiceStatus,
  SearchInvoiceRowsFilterParameter
} from "@wingspanhq/wingspan-api-sdk";

type Params = {
  /** Free-text search across the denormalized row. */
  search?: string;
  /** v3 payer (client) id to scope the list to a single client. */
  clientId?: string;
  /** Raw v3 `InvoiceStatus` values → `status.anyOf` (server-side). */
  statuses?: InvoiceStatus[];
  /** `[from, to]` — maps to the `dueDate` range filter. */
  dueDateRange?: Date[] | null;
  /** `[from, to]` — maps to the `events.paidAt` range filter. */
  paidDateRange?: Date[] | null;
};

/**
 * Build the v3 `searchInvoiceRows` filter from the dashboard's filter inputs.
 * Status filtering uses the SDK's raw `InvoiceStatus` directly (no FE-derived
 * status).
 */
export const selectorInvoiceRowsFilter = (
  params: Params
): SearchInvoiceRowsFilterParameter => {
  const filter: SearchInvoiceRowsFilterParameter = {
    metadata_invoiceType: { ne: "approvedInvoicesPayment" },
    status: { noneOf: [InvoiceStatus.CANCELLED] }
  };

  if (params.search) {
    filter.searchString = { eq: params.search };
  }

  if (params.clientId) {
    filter.payerId = { eq: params.clientId };
  }

  if (params.statuses?.length) {
    filter.status = { ...filter.status, anyOf: params.statuses };
  }

  if (params.dueDateRange?.[0] || params.dueDateRange?.[1]) {
    filter.dueDate = {
      gte: params.dueDateRange?.[0],
      lte: params.dueDateRange?.[1]
    };
  }

  if (params.paidDateRange?.[0] || params.paidDateRange?.[1]) {
    filter.events_paidAt = {
      gte: params.paidDateRange?.[0],
      lte: params.paidDateRange?.[1]
    };
  }

  return filter;
};
